<template>
  <div class="TableOfContents">
    <h4 class="title">{{ title }}</h4>
    <div class="contents">
      <SectionOrSubsections v-for="entry in contents"
        :key="entry.title"
        :entry="entry"
        class="sectionOrSubsections"
      />
    </div>
  </div>
</template>

<script>
import SectionOrSubsections from './SectionOrSubsections.vue'

export default {
  components: {
    SectionOrSubsections,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    contents: {
      type: Array,
      default: Array,
    },
  },
}
</script>

<style scoped>

.title {
  font-weight: 600;
  font-size: var(--font-size-2);
  color: var(--text-color-black);
  padding-bottom: var(--spacing-0);
  border-bottom: thin solid var(--hairline-color);
  margin-bottom: var(--spacing-0);
}

.contents {
  margin-top: var(--spacing-4);
}

.sectionOrSubsections {
  margin-top: var(--spacing-2);
  font-weight: 400;
  font-size: 0.875rem;
  color: var(--text-color-black);
}
</style>
